export default "__VITE_ASSET__COh6gwTt__"